import businessService from '../services/businessService';

const state = {
  smsBalance: null,
};

const actions = {
  async loadSmsBalance({ commit }, businessId) {
    try {
      const balance = await businessService.fetchSmsBalance(businessId);
      if (balance !== null && typeof balance === 'object') {
        commit('setSmsBalance', balance.data);
      }
    } catch (error) {
      console.error('There was an error retrieving SMS balance:', error);
      commit('setSmsBalance', null);
    }
  },
};

const mutations = {
  setSmsBalance(state, balance) {
    state.smsBalance = balance;
  },
};

const getters = {
  smsBalance: (state) => state.smsBalance,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
